module.exports = __webpack_public_path__ + "static/media/static-1-Ca.80fb8ea3.png";